export interface ActionLinkPattern {
  key: string;
  pattern: RegExp;
  uuidPattern?: RegExp;
  label: string;
  iconSvg: string;
}

const PERSON_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" stroke-linecap="round" stroke-linejoin="round"><path d="M344,144c-3.92,52.87-44,96-88,96s-84.15-43.12-88-96c-4-55,35-96,88-96S348,90,344,144Z"/><path d="M256,304c-87,0-175.3,48-191.64,138.6C62.39,453.52,68.57,464,80,464H432c11.44,0,17.62-10.48,15.65-21.4C431.3,352,343,304,256,304Z" stroke-miterlimit="10"/></svg>';

const OPEN_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" stroke-linecap="round" stroke-linejoin="round"><path d="M384,224V408a40,40,0,0,1-40,40H104a40,40,0,0,1-40-40V168a40,40,0,0,1,40-40H271.48"/><polyline points="336 64 448 64 448 176"/><line x1="224" y1="288" x2="440" y2="72"/></svg>';

const BRIEFCASE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" stroke-linecap="round" stroke-linejoin="round"><rect x="32" y="128" width="448" height="320" rx="48" ry="48"/><path d="M144,128V96a32,32,0,0,1,32-32H336a32,32,0,0,1,32,32v32"/><line x1="480" y1="240" x2="32" y2="240"/><path d="M320,240v24a8,8,0,0,1-8,8H200a8,8,0,0,1-8-8V240"/></svg>';

export const ACTION_LINK_PATTERNS: ActionLinkPattern[] = [
  {
    key: 'my-pro',
    pattern: /\/my-pro\/\d+/,
    label: 'View Pro',
    iconSvg: PERSON_ICON,
  },
  {
    key: 'shared-link',
    pattern: /\/shared-link\/[a-f0-9-]+/,
    uuidPattern: /\/shared-link\/([a-f0-9-]+)/,
    label: 'Open Link',
    iconSvg: OPEN_ICON,
  },
  {
    key: 'claim-job',
    pattern: /\/claim-job\/\d+/,
    label: 'View Job',
    iconSvg: BRIEFCASE_ICON,
  },
];

export const ACTION_TYPE_LABELS: Record<string, string> = {
  'ai_task_add_payment_method': 'Add Payment Method',
};

export function getActionLabel(actionType: string): string {
  if (ACTION_TYPE_LABELS[actionType]) {
    return ACTION_TYPE_LABELS[actionType];
  }
  return actionType
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
